export const footerStyles = {
  root: 'mt-auto border-t border-brand-700/30 bg-brand-950 text-brand-100',
  inner:
    'mx-auto flex max-w-7xl flex-col gap-6 px-4 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8',
  brand: 'flex items-center gap-3',
  logo: 'h-8 w-auto object-contain opacity-90',
  links: 'flex flex-wrap gap-4',
  link: 'font-sans text-sm text-brand-200 transition-colors hover:text-brand-400',
  copy: 'font-sans text-2xs text-brand-700 sm:text-xs',
} as const;
